import * as angular from 'angular';
import NumberSettingsList from './list/settings.phone.list';
import NumberSettings from './settings/settings.numbers.settings';
import CustomNumber from './custom/custom.number';
import DetailsDontAccept from './details/dont-accept/phone.details.dont-accept';
import DetailsForward from './details/forward/phone.details.forward';
import DetailsReceive from './details/receive/phone.details.receive';
import DetailsPhoneDnb from './details/phone-dnd/phone.settings.dnb';
import InboundNumbersService from './inbound.numbers.service';
import NumbersStateService from './numbers.state.service';
import NumbersEdit from './edit/numbers.edit';

export default angular.module('CrazyWeb.Numbers', [])
    .component("numberSettingsList", NumberSettingsList)
    .component("numberSettings", NumberSettings)
    .component("customNumber", CustomNumber)
    .component("detailsDontAccept", DetailsDontAccept)
    .component("detailsForward", DetailsForward)
    .component("detailsReceive", DetailsReceive)
    .component("phoneDnb", DetailsPhoneDnb)
    .component("editNumber", NumbersEdit)
    .service("InboundNumbersService", InboundNumbersService)
    .service("NumbersStateService", NumbersStateService).name
